<div class="container">
  @let pageStatus = pageStatus$ | async; @let userData = userData$ | async; @let customFields = customFields$ | async;
  @let controls = controls$ | async; @if (pageStatus && userData && customFields && controls) {
  <ng-container *ngIf="!pageStatus.loading">
    <div class="page-title">
      <h2>
        {{
          (!controls.isUnsubscribed
            ? 'ACCOUNT.MANAGE_SUBSCRIPTION.TITLE.MANAGE_DATA'
            : 'ACCOUNT.MANAGE_SUBSCRIPTION.TITLE.NO_DATA'
          ) | translate
        }}
      </h2>
      <h3
        [innerHTML]="
          (!controls.isUnsubscribed
            ? 'ACCOUNT.MANAGE_SUBSCRIPTION.DESCRIPTION.MANAGE_DATA'
            : 'ACCOUNT.MANAGE_SUBSCRIPTION.DESCRIPTION.NO_DATA'
          ) | translate
        "
      ></h3>
    </div>
    <div class="container__header" *ngIf="!controls.isUnsubscribed">
      <div class="container__header__title">{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.TITLE' | translate }}</div>
      <div class="container__header__info">
        <div class="container__header__vorname">
          <strong>{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.NAME' | translate }}</strong>
          {{ getCustomFieldValueById(userData.customFieldValues, firstNameId) }}
        </div>
        <div class="container__header__nachname">
          <strong>{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.SURNAME' | translate }}</strong>
          {{ getCustomFieldValueById(userData.customFieldValues, lastNameId) }}
        </div>
        <div class="container__header__email">
          <strong>{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.EMAIL' | translate }}</strong> {{ userData.email }}
        </div>
        <div
          class="container__header__geb-datum"
          *ngIf="getCustomFieldValueById(userData.customFieldValues, birthdayId) !== ''"
        >
          <strong>{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.BIRTHDATE' | translate }}</strong>
          {{ getCustomFieldValueById(userData.customFieldValues, birthdayId) | date : 'dd.MM.yyyy' }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!pageStatus.loading; else loading">
    <div class="container__body" *ngIf="!controls.isUnsubscribed; else noSubscriptionMessage">
      <div class="container__body__doi">
        <strong class="no-gap" [innerHTML]="'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.DOIHEADER' | translate"></strong>
        <div>
          <mat-checkbox
            *ngIf="controls.shouldShowUwg7"
            [checked]="onOriginCustomFieldSelected(userData.customFieldValues, uwg7Id)"
            (change)="toggleOriginCustomField(uwg7Id)"
          >
            {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.UWG7TEXT' | translate }}
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            [checked]="onOriginCustomFieldSelected(userData.customFieldValues, doiId)"
            (change)="toggleOriginCustomField(doiId)"
          >
            {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.DOITEXT' | translate }}
          </mat-checkbox>
        </div>
      </div>
      <strong
        *ngIf="onOriginCustomFieldSelected(userData.customFieldValues, doiId) && customFields.length > 0"
        class="small-gap"
      >
        {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.TEXT' | translate }}
      </strong>
      @if (onOriginCustomFieldSelected(userData.customFieldValues, doiId)) { @for (sub of
      filterSubscriptionWithoutThemes(customFields); track sub) { @let i = $index;
      <div class="subscription">
        <div class="subscription__header">
          <mat-checkbox
            [checked]="controls.isSelected[i].isSelected"
            [indeterminate]="isIntermediate(controls.isSelected[i])"
            (change)="toggleAbsenderSelection(sub.customFieldId)"
          >
            {{ sub.name }}
          </mat-checkbox>
          <button mat-icon-button type="button" (click)="toggleOptionOpen(i)">
            <mat-icon aria-hidden="false" aria-label="Toggle open themes">
              {{ controls.isOpen[i] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </button>
        </div>
        <ul [@openClose]="controls.isOpen[i] ? 'open' : 'close'">
          @for (theme of sub.values; track theme) { @let j = $index;
          <li>
            <mat-checkbox
              [checked]="controls.isSelected[i].themenSelected[j].isSelected"
              (change)="toggleThemenSelection(sub.customFieldId, theme)"
            >
              {{ theme }}
            </mat-checkbox>
          </li>
          }
        </ul>
      </div>
      } } @if (onOriginCustomFieldSelected(userData.customFieldValues, doiId) && customFields.length > 0) {
      <strong class="small-gap">{{ 'ACCOUNT.MANAGE_SUBSCRIPTION.HEADER.TEXT_THEMES' | translate }}</strong>
      } @if (onOriginCustomFieldSelected(userData.customFieldValues, doiId)) { @for (sub of
      filterSubscriptionThemes(customFields); track sub) { @let i = $index; @let relativeIndex =
      getRelativeIndexOfThemes(i, customFields);
      <div class="subscription">
        <div class="subscription__header">
          <mat-checkbox
            [checked]="controls.isSelected[relativeIndex].isSelected"
            [indeterminate]="isIntermediate(controls.isSelected[relativeIndex])"
            (change)="toggleAbsenderSelection(sub.customFieldId)"
          >
            {{ sub.name }}
          </mat-checkbox>
          <button mat-icon-button type="button" (click)="toggleOptionOpen(relativeIndex)">
            <mat-icon aria-hidden="false" aria-label="Toggle open themes">
              {{ controls.isOpen[relativeIndex] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </button>
        </div>
        <ul [@openClose]="controls.isOpen[relativeIndex] ? 'open' : 'close'">
          @for (theme of sub.values; track theme) { @let j = $index;
          <li>
            <mat-checkbox
              [checked]="controls.isSelected[relativeIndex].themenSelected[j].isSelected"
              (change)="toggleThemenSelection(sub.customFieldId, theme)"
            >
              {{ theme }}
            </mat-checkbox>
          </li>
          }
        </ul>
      </div>
      } }
    </div>
  </ng-container>
  <ng-template #noSubscriptionMessage>
    <span class="no-subscription">
      <span [innerHTML]="'ACCOUNT.MANAGE_SUBSCRIPTION.EMPTY.MESSAGE' | translate"></span>
      @if (shouldUseCustomButton) {
      <a mat-flat-button color="primary" [href]="unsubscriptionButtonLink">
        {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.EMPTY.CUSTOM_LINK' | translate : { company: companyName } }}
      </a>
      } @else {
      <a mat-flat-button color="primary" routerLink="/navigation">
        {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.EMPTY.LINK' | translate }}
      </a>
      }
    </span>
  </ng-template>
  <ng-template #loading>
    <mat-spinner />
  </ng-template>
  <div class="container__footer">
    @if (pageStatus.loading || !controls.isUnsubscribed) {
    <div id="unsubscribe-container">
      <button class="unsubscribe" type="button" [disabled]="pageStatus.loading" (click)="unmarkAll()">
        {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.BUTTON_UNSUBSCRIBE_ALL' | translate }}
      </button>
      <p
        id="unsubscribe-observation"
        [innerHTML]="'ACCOUNT.MANAGE_SUBSCRIPTION.UNSUBSCRIBE_ALL_OBSERVATION' | translate"
      ></p>
    </div>
    <button
      mat-flat-button
      class="save"
      color="primary"
      type="button"
      [disabled]="pageStatus.loading"
      (click)="submitFormInfo(controls.isSelected, customFields, userData.customFieldValues)"
    >
      {{ 'ACCOUNT.MANAGE_SUBSCRIPTION.BUTTON_SUBMIT' | translate }}
    </button>
    }
  </div>
  }
</div>
